// src/App.js
import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './AuthContext';
import LoginPage       from './pages/LoginPage';
import AuthCallback    from './pages/AuthCallback';
import AdminLayout     from './pages/AdminLayout';
import AdminDashboard  from './pages/AdminDashboard';
import AdminUsers      from './pages/AdminUsers';
import AdminNews       from './pages/AdminNews';
import AdminStore      from './pages/AdminStore';
import AdminSpotlight  from './pages/AdminSpotlight';
import AdminLive       from './pages/AdminLive';
import AdminContact    from './pages/AdminContact';
import AdminHighlights from './pages/AdminHighlights';
import AdminEvents     from './pages/AdminEvents';

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/"              element={<LoginPage />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/admin"         element={<AdminLayout />}>
            <Route index               element={<AdminDashboard />} />
            <Route path="users"        element={<AdminUsers />} />
            <Route path="news"         element={<AdminNews />} />
            <Route path="store"        element={<AdminStore />} />
            <Route path="spotlight"    element={<AdminSpotlight />} />
            <Route path="live"         element={<AdminLive />} />
            <Route path="contact"      element={<AdminContact />} />
            <Route path="highlights"   element={<AdminHighlights />} />
            <Route path="events"       element={<AdminEvents />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}